import { render, staticRenderFns } from "./view-fund.vue?vue&type=template&id=752fc08c&scoped=true&"
import script from "./view-fund.vue?vue&type=script&lang=js&"
export * from "./view-fund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752fc08c",
  null
  
)

export default component.exports